import { DatePipe, formatDate } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'app/api-services/api.service';
import { viewUser } from 'app/meta.service';
import moment from 'moment';

@Component({
  selector: 'app-view-plans',
  templateUrl: './view-plans.component.html',
  styleUrls: ['./view-plans.component.scss']
})


export class ViewPlansComponent {
  plans = [];
  planDurations=[];
  PlanBenefits = [];
  suitableForCustomers = null;
  isHourly =  false;
 
  reportToUserNames = [];
 
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public apiService: ApiService, private datePipe: DatePipe
  ) { }
  ngOnInit() {
    this.getUserById();
  }
  getUserById() {
    this.plans = this.data.data;
    this.isHourly = this.data.data[0].is_hourly;
    this.plans.forEach(element => {
      this.planDurations = element.plan_durations;
      this.planDurations.forEach(pDuration => {
        pDuration.planDurationBranchNames = pDuration.applicable_to_branch_id_names.map(branchObj => branchObj.name)
      })
      this.PlanBenefits = element.benefits;
      this.suitableForCustomers = element.suitable_for_customers;
      element.trainerRoleNames = element.schedule_roles.map(scheduleRole => {
        return scheduleRole.name
      }),
      element.planBranchNames = element.applicable_to_branch_id_names.map(branchObj => branchObj.name)

    });
  }
}

